"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var BaseStore_1 = __importDefault(require("../../Core/BaseStore"));
var CrewService_1 = __importDefault(require("../Service/CrewService"));
var CrewStore = /** @class */ (function (_super) {
    __extends(CrewStore, _super);
    function CrewStore(session) {
        var _this = _super.call(this) || this;
        _this.driverCurrentlyAssigned = new Map();
        _this.crewsByTeam = new Map();
        _this.state$.subscribe(function (state) {
            var crews = _this.getItems();
            var users = [];
            crews.forEach(function (crew) {
                var normalizedDrivers = (crew.drivers || []).map(function (driver) { return (__assign(__assign({}, driver), { team_ids: [crew.team_id] })); });
                var normalizedPrimaryDriver = __assign(__assign({}, crew.primary_driver), { team_ids: [crew.team_id] });
                users.push.apply(users, __spreadArray(__spreadArray([], __read(normalizedDrivers), false), [normalizedPrimaryDriver], false));
            });
            (0, rxjs_1.from)(users)
                .pipe((0, operators_1.groupBy)(function (user) { return (0, lodash_1.first)(user.team_ids); }, function (user) { return user; }), (0, operators_1.mergeMap)(function (group) { return (0, rxjs_1.zip)((0, rxjs_1.of)(group.key), group.pipe((0, operators_1.toArray)())); }))
                .subscribe(function (_a) {
                var _b = __read(_a, 2), teamId = _b[0], users = _b[1];
                _this.driverCurrentlyAssigned.set(teamId, users.map(function (user) { return user.id; }));
            });
        });
        _this.state$.subscribe(function (state) {
            (0, rxjs_1.from)(_this.getItems())
                .pipe((0, operators_1.groupBy)(function (crew) { return crew.team_id; }, function (crew) { return crew; }), (0, operators_1.mergeMap)(function (group) { return (0, rxjs_1.zip)((0, rxjs_1.of)(group.key), group.pipe((0, operators_1.toArray)())); }))
                .subscribe(function (_a) {
                var _b = __read(_a, 2), teamId = _b[0], crews = _b[1];
                _this.crewsByTeam.set(teamId, crews);
            });
        });
        _this.crewService = new CrewService_1.default(session, _this);
        return _this;
    }
    CrewStore.prototype.getCrewPlannedRoute = function (crewId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getById(crewId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.getItem(crewId).planned_route];
                }
            });
        });
    };
    CrewStore.prototype.getAllByTeam = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crewService.getAllByTeam(teamId)];
                    case 1:
                        response = _a.sent();
                        if (this.crewsByTeam.get(teamId)) {
                            response.forEach(function (item) { return _this.updateInStore(item); });
                        }
                        else {
                            response.forEach(function (item) { return _this.addToStore(item); });
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewStore.prototype.getById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getItem(id);
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._fetch(id)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a];
                }
            });
        });
    };
    CrewStore.prototype.create = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crewService.create(request)];
                    case 1:
                        response = _a.sent();
                        this.addToStore(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewStore.prototype.update = function (id, crew) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crewService.update(id, crew)];
                    case 1:
                        response = _a.sent();
                        this.updateInStore(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewStore.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crewService.delete(id)];
                    case 1:
                        _a.sent();
                        this.removeFromStore(id);
                        return [2 /*return*/];
                }
            });
        });
    };
    CrewStore.prototype._fetch = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crewService.get(id)];
                    case 1:
                        response = _a.sent();
                        this.addToStore(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return CrewStore;
}(BaseStore_1.default));
exports.default = CrewStore;
//# sourceMappingURL=CrewStore.js.map